<div class="flex h-full bg-grey-900 md:px-4 md:items-center md:justify-center">
  <div class="flex flex-col gap-4 bg-white p-10 md:max-w-md md:rounded-sm">
    <img width="100" height="100" ngSrc="assets/images/jcb-impact-logo.svg" alt="JCB Impact Logo">
    <h1 class="text-black text-3xl">{{ 'unauthenticated.title' | transloco }}</h1>
    <p class="text-black text-lg">{{ 'unauthenticated.body' | transloco }}</p>
    <button class="btn-primary">
      <a [href]=hubUrl>
        {{ 'unauthenticated.login' | transloco }}
      </a>
    </button>
  </div>
</div>
